import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { HttpService } from './http.service';
import { defaultCompany } from './util/default-company';

@Injectable({
  providedIn: 'root'
})
export class CompanyResolverResolver  {

  constructor( private http: HttpService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const param = route.params;

    return new Promise(async (resolve, reject) => {
      var existingCompany = this.http.getCompany();

      if (!existingCompany || existingCompany.length == 0) {
        existingCompany = await this.http.setCompany();
      }

      if (param.company_uuid && param.company_uuid !== this.http.getStaticSelectedCompany()) {
        this.http.setSelectedCompany(param.company_uuid);
      } else if ((!param.company_uuid || param.company_uuid == null || param.company_uuid == undefined) && existingCompany.length > 0) {
        const existing = defaultCompany(existingCompany);
        this.http.setSelectedCompany(existing.uuid);
        if (state.url == "/lo") {
          if(!existing.can_view && existing.voucher) {
            this.http.navigate(['/lo', existing.uuid, "setting-voucher"])
            return resolve(false);
          }

          let permission = await this.http.getPermission();
          let path = permission[0]?.children[0]?.path;
          this.http.navigate(['/lo', existing.uuid, path ?? "unauthorized"])
          return resolve(false);
        }
      }

      resolve(true);
    });

  }
  

}
